// Games to hide and exclude from rankings.
// Each entry is a { tournamentId, gameTitle } pair.
export const IGNORED_GAMES: { tournamentId: string; gameTitle: string }[] = [
  { tournamentId: '1072', gameTitle: 'Time Machine 2019' },
];

export function filterIgnoredGames(games: any[], tournamentId: string): any[] {
  const ignored = IGNORED_GAMES.filter(g => String(g.tournamentId) === String(tournamentId));
  if (ignored.length === 0) return games;
  const ignoredTitles = new Set(ignored.map(g => g.gameTitle));
  return games.filter((game: any) => !ignoredTitles.has(game.title));
}
